import {
  Box,
  Button,
  Stack,
  SvgIcon,
  Typography,
  useTheme,
} from "@mui/material";
import { Link as ReactRouterLink } from "react-router-dom";

import { useAuth } from "../../context/authContext";
import GoogleLoginButton from "../../components/GoogleLoginButton";
import MotionInView from "../../components/MotionInView";

import { ReactComponent as ExploreIcon } from "../../assets/IconExplore.svg";

import LogoLargeLight from "../../assets/LogoLargeLight.svg";
import LogoLargeDark from "../../assets/LogoLargeDark.svg";

// Seconds between the hero's logo, tagline and buttons rising in
const STAGGER = 0.1;

/**
 * The homepage's opening: logo, tagline and sign-in/explore buttons. Each
 * rises in on load, one after another, matching the app pages' entrances.
 * MotionInView is the element itself (via `component`) rather than a wrapper,
 * so the percentage widths and flex layout here are unchanged.
 */
export default function HeroSection() {
  const theme = useTheme();
  const { user } = useAuth();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%",
          alignItems: "center",
          gap: 3,
          px: { xs: 2, md: 0 },
        }}
      >
        <Box
          component={MotionInView}
          sx={{
            width: { xs: "90%", sm: "50%", lg: "40%" },
            mt: { xs: 10, sm: 0 },
          }}
        >
          <img
            src={theme.palette.mode === "dark" ? LogoLargeDark : LogoLargeLight}
            alt="Curate logo — track movies, TV shows and books"
            width="100%"
          />
        </Box>

        <Typography
          component={MotionInView}
          delay={STAGGER}
          color="text.primary"
          textAlign="center"
          sx={{ textWrap: "balance" }}
        >
          Track everything you watch and read. Discover movies, books and TV
          through real human taste.
          {/* Curate your taste. Discover people who share it. */}
        </Typography>
      </Box>

      <Stack
        component={MotionInView}
        delay={STAGGER * 2}
        direction={{ md: "row", xs: "column" }}
        // spacing={{ md: 4, xs: user ? 4 : 12 }}
        spacing={{ md: 2, xs: 2 }}
        alignItems="center"
        sx={{
          pb: { xs: 4, sm: 0 },
          pt: 1,
        }}
      >
        {user ? (
          <Button
            variant="contained"
            component={ReactRouterLink}
            to={`/track/u/${user.username}`}
            sx={{ width: { xs: "210px" } }}
          >
            Return to app
          </Button>
        ) : (
          <GoogleLoginButton sx={{ width: { xs: "210px", md: "auto" } }} />
        )}
        {/* Logged-out visitors can browse the public explore feed before signing in */}
        {!user && (
          <Button
            variant="outlined"
            component={ReactRouterLink}
            to="/explore"
            startIcon={
              <SvgIcon fontSize="small">
                <ExploreIcon />
              </SvgIcon>
            }
            sx={{ width: { xs: "210px", md: "auto" } }}
          >
            Explore now
          </Button>
        )}
      </Stack>
    </>
  );
}
